import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {DashboardStyles} from './DashboardStyles'
import { isEmpty } from 'lodash';

const userColumnList = ['First Name', 'Last Name', 'Last Login', 'Package Name', 'Email', 'Phone No', 'City']
const useStyles = makeStyles({
  table: {
    minWidth: 300
  },
});

export default function UsersTable(props) {
  const classes = useStyles();
  const data = props.data;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
          {userColumnList.map((text, index) => (           
            <TableCell key={index} align="left" style={DashboardStyles.headingColor}>{text}</TableCell>))}
            </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.first_name}>
              <TableCell> {row.first_name} </TableCell>
              <TableCell> {row.last_name} </TableCell>
              <TableCell> {isEmpty(row.last_login)?"Never Login":row.last_login} </TableCell>
              <TableCell> {row.package_name} </TableCell>
              <TableCell align="left">{row.email}</TableCell>
              <TableCell align="left">{row.phone}</TableCell>
              <TableCell align="left">{row.city}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
